/**
 * Alarm panels migrated from tools/camera-additions.json. Hikvision AX Pro
 * / AX Hybrid Pro (DS-PHA / DS-PR series) — rebranded Pyronix Enforcer
 * hardware, EN 50131 Grade 2/3.
 *
 * AUTO-GENERATED by tools/generate-migrated-catalogs.py from agent research
 * outputs in tools/equipment-research/. DO NOT edit by hand — re-run the
 * script if specs change. Generated on 2026-05-19.
 */
import type { EquipmentCatalogEntry } from './equipmentCatalogEntry';

export const MIGRATED_ALARM_PANELS: EquipmentCatalogEntry[] = [
  {
    id: 'hikvision-ds-pha64-lp',
    manufacturer: 'Hikvision',
    model: 'DS-PHA64-LP',
    category: 'alarm-panel',
    tagline: 'DS-PHA64-LP — 64-zone alarm panel, EN 50131 Grade Grade 2',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Alarm-Products/wired-intrusion-alarm/ax-hybrid-pro/ds-pha64-lp/',
    specs: {
      series: 'AX Pro',
      zonesOnboard: 8,
      zonesMax: 64,
      partitions: 4,
      grade: 2,
      outputsOnboard: 8,
      communicators: ['Ethernet', 'GSM-LTE', 'wireless'],
    },
  },
  {
    id: 'hikvision-ds-pha64-lp-b',
    manufacturer: 'Hikvision',
    model: 'DS-PHA64-LP-B',
    category: 'alarm-panel',
    tagline: 'DS-PHA64-LP-B — 64-zone alarm panel, EN 50131 Grade Grade 2',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Alarm-Products/wired-intrusion-alarm/ax-hybrid-pro/ds-pha64-lp/',
    specs: {
      series: 'AX Pro',
      zonesOnboard: 8,
      zonesMax: 64,
      partitions: 4,
      grade: 2,
      outputsOnboard: 8,
      communicators: ['Ethernet', 'GSM-LTE', 'wireless'],
    },
  },
  {
    id: 'hikvision-ds-pha64-kit-wb-b',
    manufacturer: 'Hikvision',
    model: 'DS-PHA64-KIT-WB-B',
    category: 'alarm-panel',
    tagline: 'DS-PHA64-KIT-WB-B — 64-zone alarm panel, EN 50131 Grade Grade 2',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Alarm-Products/wired-intrusion-alarm/ax-hybrid-pro/ds-pha64-lp/',
    specs: {
      series: 'AX Pro',
      zonesOnboard: 8,
      zonesMax: 64,
      partitions: 4,
      grade: 2,
      outputsOnboard: 8,
      communicators: ['Ethernet', 'GSM-LTE', 'wireless'],
    },
  },
  {
    id: 'hikvision-ds-pha64-kit-we-b',
    manufacturer: 'Hikvision',
    model: 'DS-PHA64-KIT-WE-B',
    category: 'alarm-panel',
    tagline: 'DS-PHA64-KIT-WE-B — 64-zone alarm panel, EN 50131 Grade Grade 2',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Alarm-Products/wired-intrusion-alarm/ax-hybrid-pro/ds-pha64-lp/',
    specs: {
      series: 'AX Pro',
      zonesOnboard: 8,
      zonesMax: 64,
      partitions: 4,
      grade: 2,
      outputsOnboard: 8,
      communicators: ['Ethernet', 'GSM-LTE', 'wireless'],
    },
  },
  {
    id: 'hikvision-ds-pha64-m',
    manufacturer: 'Hikvision',
    model: 'DS-PHA64-M',
    category: 'alarm-panel',
    tagline: 'DS-PHA64-M — 64-zone alarm panel, EN 50131 Grade Grade 2',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Alarm-Products/wired-intrusion-alarm/ax-hybrid-pro/ds-pha64-lp/',
    specs: {
      series: 'AX Pro',
      zonesOnboard: 8,
      zonesMax: 64,
      partitions: 4,
      grade: 2,
      outputsOnboard: 8,
      communicators: ['Ethernet', 'GSM-LTE', 'wireless'],
    },
  },
  {
    id: 'hikvision-ds-pha64-b',
    manufacturer: 'Hikvision',
    model: 'DS-PHA64-B',
    category: 'alarm-panel',
    tagline: 'DS-PHA64-B — 64-zone alarm panel, EN 50131 Grade Grade 2',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Alarm-Products/wired-intrusion-alarm/ax-hybrid-pro/ds-pha64-lp/',
    specs: {
      series: 'AX Pro',
      zonesOnboard: 8,
      zonesMax: 64,
      partitions: 4,
      grade: 2,
      outputsOnboard: 8,
      communicators: ['Ethernet', 'GSM-LTE', 'wireless'],
    },
  },
  {
    id: 'hikvision-ds-pha64-lp-np',
    manufacturer: 'Hikvision',
    model: 'DS-PHA64-LP-NP',
    category: 'alarm-panel',
    tagline: 'DS-PHA64-LP-NP — 64-zone alarm panel, EN 50131 Grade Grade 2',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Alarm-Products/wired-intrusion-alarm/ax-hybrid-pro/ds-pha64-lp/',
    specs: {
      series: 'AX Pro',
      zonesOnboard: 8,
      zonesMax: 64,
      partitions: 4,
      grade: 2,
      outputsOnboard: 8,
      communicators: ['Ethernet', 'GSM-LTE', 'wireless'],
    },
  },
  {
    id: 'hikvision-ds-pha64-w4p2',
    manufacturer: 'Hikvision',
    model: 'DS-PHA64-W4P2',
    category: 'alarm-panel',
    tagline: 'DS-PHA64-W4P2 — 64-zone alarm panel, EN 50131 Grade Grade 2',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Alarm-Products/wired-intrusion-alarm/ax-hybrid-pro/ds-pha64-lp/',
    specs: {
      series: 'AX Pro',
      zonesOnboard: 8,
      zonesMax: 64,
      partitions: 4,
      grade: 2,
      outputsOnboard: 8,
      communicators: ['Ethernet', 'GSM-LTE', 'wireless'],
    },
  },
  {
    id: 'hikvision-ds-pha64-p2',
    manufacturer: 'Hikvision',
    model: 'DS-PHA64-P2',
    category: 'alarm-panel',
    tagline: 'DS-PHA64-P2 — 64-zone alarm panel, EN 50131 Grade Grade 2',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Alarm-Products/wired-intrusion-alarm/ax-hybrid-pro/ds-pha64-lp/',
    specs: {
      series: 'AX Pro',
      zonesOnboard: 8,
      zonesMax: 64,
      partitions: 4,
      grade: 2,
      outputsOnboard: 8,
      communicators: ['Ethernet', 'GSM-LTE', 'wireless'],
    },
  },
  {
    id: 'hikvision-ds-pha64-kit-we',
    manufacturer: 'Hikvision',
    model: 'DS-PHA64-KIT-WE',
    category: 'alarm-panel',
    tagline: 'DS-PHA64-KIT-WE — 64-zone alarm panel, EN 50131 Grade Grade 2',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Alarm-Products/wired-intrusion-alarm/ax-hybrid-pro/ds-pha64-lp/',
    specs: {
      series: 'AX Pro',
      zonesOnboard: 8,
      zonesMax: 64,
      partitions: 4,
      grade: 2,
      outputsOnboard: 8,
      communicators: ['Ethernet', 'GSM-LTE', 'wireless'],
    },
  },
  {
    id: 'hikvision-ds-pha64-kit-wb',
    manufacturer: 'Hikvision',
    model: 'DS-PHA64-KIT-WB',
    category: 'alarm-panel',
    tagline: 'DS-PHA64-KIT-WB — 64-zone alarm panel, EN 50131 Grade Grade 2',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Alarm-Products/wired-intrusion-alarm/ax-hybrid-pro/ds-pha64-lp/',
    specs: {
      series: 'AX Pro',
      zonesOnboard: 8,
      zonesMax: 64,
      partitions: 4,
      grade: 2,
      outputsOnboard: 8,
      communicators: ['Ethernet', 'GSM-LTE', 'wireless'],
    },
  },
  {
    id: 'hikvision-ds-pha64-lp-b-msm-moved',
    manufacturer: 'Hikvision',
    model: 'DS-PHA64-LP-B-_MSM_MOVED',
    category: 'alarm-panel',
    tagline: 'DS-PHA64-LP-B-_MSM_MOVED — 64-zone alarm panel, EN 50131 Grade Grade 2',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Alarm-Products/wired-intrusion-alarm/ax-hybrid-pro/ds-pha64-lp/',
    specs: {
      series: 'AX Pro',
      zonesOnboard: 8,
      zonesMax: 64,
      partitions: 4,
      grade: 2,
      outputsOnboard: 8,
      communicators: ['Ethernet', 'GSM-LTE', 'wireless'],
    },
  },
  {
    id: 'hikvision-ds-pha64-kit-wb-msm-moved',
    manufacturer: 'Hikvision',
    model: 'DS-PHA64-KIT-WB_MSM_MOVED',
    category: 'alarm-panel',
    tagline: 'DS-PHA64-KIT-WB_MSM_MOVED — 64-zone alarm panel, EN 50131 Grade Grade 2',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Alarm-Products/wired-intrusion-alarm/ax-hybrid-pro/ds-pha64-lp/',
    specs: {
      series: 'AX Pro',
      zonesOnboard: 8,
      zonesMax: 64,
      partitions: 4,
      grade: 2,
      outputsOnboard: 8,
      communicators: ['Ethernet', 'GSM-LTE', 'wireless'],
    },
  },
  {
    id: 'hikvision-ds-pha64-kit-wb-b-msm-moved',
    manufacturer: 'Hikvision',
    model: 'DS-PHA64-KIT-WB-B-_MSM_MOVED',
    category: 'alarm-panel',
    tagline: 'DS-PHA64-KIT-WB-B-_MSM_MOVED — 64-zone alarm panel, EN 50131 Grade Grade 2',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Alarm-Products/wired-intrusion-alarm/ax-hybrid-pro/ds-pha64-lp/',
    specs: {
      series: 'AX Pro',
      zonesOnboard: 8,
      zonesMax: 64,
      partitions: 4,
      grade: 2,
      outputsOnboard: 8,
      communicators: ['Ethernet', 'GSM-LTE', 'wireless'],
    },
  },
  {
    id: 'hikvision-ds-pha64-w4b',
    manufacturer: 'Hikvision',
    model: 'DS-PHA64-W4B',
    category: 'alarm-panel',
    tagline: 'DS-PHA64-W4B — 64-zone alarm panel, EN 50131 Grade Grade 2',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Alarm-Products/wired-intrusion-alarm/ax-hybrid-pro/ds-pha64-lp/',
    specs: {
      series: 'AX Pro',
      zonesOnboard: 8,
      zonesMax: 64,
      partitions: 4,
      grade: 2,
      outputsOnboard: 8,
      communicators: ['Ethernet', 'GSM-LTE', 'wireless'],
    },
  },
  {
    id: 'hikvision-ds-pha64-w4m',
    manufacturer: 'Hikvision',
    model: 'DS-PHA64-W4M',
    category: 'alarm-panel',
    tagline: 'DS-PHA64-W4M — 64-zone alarm panel, EN 50131 Grade Grade 2',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Alarm-Products/wired-intrusion-alarm/ax-hybrid-pro/ds-pha64-lp/',
    specs: {
      series: 'AX Pro',
      zonesOnboard: 8,
      zonesMax: 64,
      partitions: 4,
      grade: 2,
      outputsOnboard: 8,
      communicators: ['Ethernet', 'GSM-LTE', 'wireless'],
    },
  },
  {
    id: 'hikvision-ds-pha64-kit-we-b',
    manufacturer: 'Hikvision',
    model: 'DS-PHA64-KIT-WE-B-',
    category: 'alarm-panel',
    tagline: 'DS-PHA64-KIT-WE-B- — 64-zone alarm panel, EN 50131 Grade Grade 2',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Alarm-Products/wired-intrusion-alarm/ax-hybrid-pro/ds-pha64-lp/',
    specs: {
      series: 'AX Pro',
      zonesOnboard: 8,
      zonesMax: 64,
      partitions: 4,
      grade: 2,
      outputsOnboard: 8,
      communicators: ['Ethernet', 'GSM-LTE', 'wireless'],
    },
  },
  {
    id: 'hikvision-ds-pha64-lp-b',
    manufacturer: 'Hikvision',
    model: 'DS-PHA64-LP-B-',
    category: 'alarm-panel',
    tagline: 'DS-PHA64-LP-B- — 64-zone alarm panel, EN 50131 Grade Grade 2',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Alarm-Products/wired-intrusion-alarm/ax-hybrid-pro/ds-pha64-lp/',
    specs: {
      series: 'AX Pro',
      zonesOnboard: 8,
      zonesMax: 64,
      partitions: 4,
      grade: 2,
      outputsOnboard: 8,
      communicators: ['Ethernet', 'GSM-LTE', 'wireless'],
    },
  },
  {
    id: 'hikvision-ds-pha64-kit-wb-b',
    manufacturer: 'Hikvision',
    model: 'DS-PHA64-KIT-WB-B-',
    category: 'alarm-panel',
    tagline: 'DS-PHA64-KIT-WB-B- — 64-zone alarm panel, EN 50131 Grade Grade 2',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Alarm-Products/wired-intrusion-alarm/ax-hybrid-pro/ds-pha64-lp/',
    specs: {
      series: 'AX Pro',
      zonesOnboard: 8,
      zonesMax: 64,
      partitions: 4,
      grade: 2,
      outputsOnboard: 8,
      communicators: ['Ethernet', 'GSM-LTE', 'wireless'],
    },
  },
  {
    id: 'hikvision-ds-pha48-ep',
    manufacturer: 'Hikvision',
    model: 'DS-PHA48-EP',
    category: 'alarm-panel',
    tagline: 'DS-PHA48-EP — 48-zone alarm panel, EN 50131 Grade Grade 2',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Alarm-Products/wired-intrusion-alarm/ax-hybrid-pro/ds-pha48-ep/',
    specs: {
      series: 'AX Pro',
      zonesOnboard: 8,
      zonesMax: 48,
      partitions: 4,
      grade: 2,
      outputsOnboard: 4,
      communicators: ['Ethernet', 'wireless'],
    },
  },
  {
    id: 'hikvision-ds-pha48-ep-b',
    manufacturer: 'Hikvision',
    model: 'DS-PHA48-EP-B',
    category: 'alarm-panel',
    tagline: 'DS-PHA48-EP-B — 48-zone alarm panel, EN 50131 Grade Grade 2',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Alarm-Products/wired-intrusion-alarm/ax-hybrid-pro/ds-pha48-ep/',
    specs: {
      series: 'AX Pro',
      zonesOnboard: 8,
      zonesMax: 48,
      partitions: 4,
      grade: 2,
      outputsOnboard: 4,
      communicators: ['Ethernet', 'wireless'],
    },
  },
  {
    id: 'hikvision-ds-pha48-ep-b-msm-moved',
    manufacturer: 'Hikvision',
    model: 'DS-PHA48-EP-B-_MSM_MOVED',
    category: 'alarm-panel',
    tagline: 'DS-PHA48-EP-B-_MSM_MOVED — 48-zone alarm panel, EN 50131 Grade Grade 2',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Alarm-Products/wired-intrusion-alarm/ax-hybrid-pro/ds-pha48-ep/',
    specs: {
      series: 'AX Pro',
      zonesOnboard: 8,
      zonesMax: 48,
      partitions: 4,
      grade: 2,
      outputsOnboard: 4,
      communicators: ['Ethernet', 'wireless'],
    },
  },
  {
    id: 'hikvision-ds-pha48-ep-b',
    manufacturer: 'Hikvision',
    model: 'DS-PHA48-EP-B-',
    category: 'alarm-panel',
    tagline: 'DS-PHA48-EP-B- — 48-zone alarm panel, EN 50131 Grade Grade 2',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Alarm-Products/wired-intrusion-alarm/ax-hybrid-pro/ds-pha48-ep/',
    specs: {
      series: 'AX Pro',
      zonesOnboard: 8,
      zonesMax: 48,
      partitions: 4,
      grade: 2,
      outputsOnboard: 4,
      communicators: ['Ethernet', 'wireless'],
    },
  },
  {
    id: 'hikvision-ds-pha20-w2p',
    manufacturer: 'Hikvision',
    model: 'DS-PHA20-W2P',
    category: 'alarm-panel',
    tagline: 'DS-PHA20-W2P — 20-zone alarm panel, EN 50131 Grade Grade 2',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Alarm-Products/wired-intrusion-alarm/ax-hybrid-pro/ds-pha20-w2p/',
    specs: {
      series: 'AX Pro',
      zonesOnboard: 4,
      zonesMax: 20,
      partitions: 4,
      grade: 2,
      outputsOnboard: 2,
      communicators: ['Ethernet', 'wireless'],
    },
  },
  {
    id: 'hikvision-ds-pha20-p',
    manufacturer: 'Hikvision',
    model: 'DS-PHA20-P',
    category: 'alarm-panel',
    tagline: 'DS-PHA20-P — 20-zone alarm panel, EN 50131 Grade Grade 2',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Alarm-Products/wired-intrusion-alarm/ax-hybrid-pro/ds-pha20-w2p/',
    specs: {
      series: 'AX Pro',
      zonesOnboard: 4,
      zonesMax: 20,
      partitions: 4,
      grade: 2,
      outputsOnboard: 2,
      communicators: ['Ethernet', 'wireless'],
    },
  },
  {
    id: 'hikvision-ds-pha20-b',
    manufacturer: 'Hikvision',
    model: 'DS-PHA20-B',
    category: 'alarm-panel',
    tagline: 'DS-PHA20-B — 20-zone alarm panel, EN 50131 Grade Grade 2',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Alarm-Products/wired-intrusion-alarm/ax-hybrid-pro/ds-pha20-w2p/',
    specs: {
      series: 'AX Pro',
      zonesOnboard: 4,
      zonesMax: 20,
      partitions: 4,
      grade: 2,
      outputsOnboard: 2,
      communicators: ['Ethernet', 'wireless'],
    },
  },
  {
    id: 'hikvision-ds-pha20-m',
    manufacturer: 'Hikvision',
    model: 'DS-PHA20-M',
    category: 'alarm-panel',
    tagline: 'DS-PHA20-M — 20-zone alarm panel, EN 50131 Grade Grade 2',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Alarm-Products/wired-intrusion-alarm/ax-hybrid-pro/ds-pha20-w2p/',
    specs: {
      series: 'AX Pro',
      zonesOnboard: 4,
      zonesMax: 20,
      partitions: 4,
      grade: 2,
      outputsOnboard: 2,
      communicators: ['Ethernet', 'wireless'],
    },
  },
  {
    id: 'hikvision-ds-pha20-w2b',
    manufacturer: 'Hikvision',
    model: 'DS-PHA20-W2B',
    category: 'alarm-panel',
    tagline: 'DS-PHA20-W2B — 20-zone alarm panel, EN 50131 Grade Grade 2',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Alarm-Products/wired-intrusion-alarm/ax-hybrid-pro/ds-pha20-w2p/',
    specs: {
      series: 'AX Pro',
      zonesOnboard: 4,
      zonesMax: 20,
      partitions: 4,
      grade: 2,
      outputsOnboard: 2,
      communicators: ['Ethernet', 'wireless'],
    },
  },
  {
    id: 'hikvision-ds-pha20-w2m',
    manufacturer: 'Hikvision',
    model: 'DS-PHA20-W2M',
    category: 'alarm-panel',
    tagline: 'DS-PHA20-W2M — 20-zone alarm panel, EN 50131 Grade Grade 2',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Alarm-Products/wired-intrusion-alarm/ax-hybrid-pro/ds-pha20-w2p/',
    specs: {
      series: 'AX Pro',
      zonesOnboard: 4,
      zonesMax: 20,
      partitions: 4,
      grade: 2,
      outputsOnboard: 2,
      communicators: ['Ethernet', 'wireless'],
    },
  },
  {
    id: 'hikvision-ds-pr1-we',
    manufacturer: 'Hikvision',
    model: 'DS-PR1-WE',
    category: 'alarm-panel',
    tagline: 'DS-PR1-WE — 96-zone alarm panel, EN 50131 Grade Grade 2',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Alarm-Products/wireless-intrusion-alarm/ax-pro/ds-pr1-we/',
    specs: {
      series: 'AX Pro',
      zonesOnboard: 96,
      zonesMax: 96,
      partitions: 4,
      grade: 2,
      communicators: ['Ethernet', 'GSM-LTE', 'wireless'],
    },
  },
  {
    id: 'hikvision-ds-pr1-wb',
    manufacturer: 'Hikvision',
    model: 'DS-PR1-WB',
    category: 'alarm-panel',
    tagline: 'DS-PR1-WB — 96-zone alarm panel, EN 50131 Grade Grade 2',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Alarm-Products/wireless-intrusion-alarm/ax-pro/ds-pr1-we/',
    specs: {
      series: 'AX Pro',
      zonesOnboard: 96,
      zonesMax: 96,
      partitions: 4,
      grade: 2,
      communicators: ['Ethernet', 'GSM-LTE', 'wireless'],
    },
  },
  {
    id: 'hikvision-ds-pr1-we-b',
    manufacturer: 'Hikvision',
    model: 'DS-PR1-WE-B',
    category: 'alarm-panel',
    tagline: 'DS-PR1-WE-B — 96-zone alarm panel, EN 50131 Grade Grade 2',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Alarm-Products/wireless-intrusion-alarm/ax-pro/ds-pr1-we/',
    specs: {
      series: 'AX Pro',
      zonesOnboard: 96,
      zonesMax: 96,
      partitions: 4,
      grade: 2,
      communicators: ['Ethernet', 'GSM-LTE', 'wireless'],
    },
  },
  {
    id: 'hikvision-ds-pr1-wb-b',
    manufacturer: 'Hikvision',
    model: 'DS-PR1-WB-B',
    category: 'alarm-panel',
    tagline: 'DS-PR1-WB-B — 96-zone alarm panel, EN 50131 Grade Grade 2',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Alarm-Products/wireless-intrusion-alarm/ax-pro/ds-pr1-we/',
    specs: {
      series: 'AX Pro',
      zonesOnboard: 96,
      zonesMax: 96,
      partitions: 4,
      grade: 2,
      communicators: ['Ethernet', 'GSM-LTE', 'wireless'],
    },
  },
  {
    id: 'hikvision-ds-pr1-60',
    manufacturer: 'Hikvision',
    model: 'DS-PR1-60',
    category: 'alarm-panel',
    tagline: 'DS-PR1-60 — 96-zone alarm panel, EN 50131 Grade Grade 2',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Alarm-Products/wireless-intrusion-alarm/ax-pro/ds-pr1-we/',
    specs: {
      series: 'AX Pro',
      zonesOnboard: 96,
      zonesMax: 96,
      partitions: 4,
      grade: 2,
      communicators: ['Ethernet', 'GSM-LTE', 'wireless'],
    },
  },
  {
    id: 'hikvision-ds-pr1-60v',
    manufacturer: 'Hikvision',
    model: 'DS-PR1-60V',
    category: 'alarm-panel',
    tagline: 'DS-PR1-60V — 96-zone alarm panel, EN 50131 Grade Grade 2',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Alarm-Products/wireless-intrusion-alarm/ax-pro/ds-pr1-we/',
    specs: {
      series: 'AX Pro',
      zonesOnboard: 96,
      zonesMax: 96,
      partitions: 4,
      grade: 2,
      communicators: ['Ethernet', 'GSM-LTE', 'wireless'],
    },
  },
  {
    id: 'hikvision-ds-pr1-wb1',
    manufacturer: 'Hikvision',
    model: 'DS-PR1-WB1',
    category: 'alarm-panel',
    tagline: 'DS-PR1-WB1 — 96-zone alarm panel, EN 50131 Grade Grade 2',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Alarm-Products/wireless-intrusion-alarm/ax-pro/ds-pr1-we/',
    specs: {
      series: 'AX Pro',
      zonesOnboard: 96,
      zonesMax: 96,
      partitions: 4,
      grade: 2,
      communicators: ['Ethernet', 'GSM-LTE', 'wireless'],
    },
  },
  {
    id: 'hikvision-ds-pr1-60-msm-moved',
    manufacturer: 'Hikvision',
    model: 'DS-PR1-60_MSM_MOVED',
    category: 'alarm-panel',
    tagline: 'DS-PR1-60_MSM_MOVED — 96-zone alarm panel, EN 50131 Grade Grade 2',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Alarm-Products/wireless-intrusion-alarm/ax-pro/ds-pr1-we/',
    specs: {
      series: 'AX Pro',
      zonesOnboard: 96,
      zonesMax: 96,
      partitions: 4,
      grade: 2,
      communicators: ['Ethernet', 'GSM-LTE', 'wireless'],
    },
  },
  {
    id: 'hikvision-ds-pr1-wb-b',
    manufacturer: 'Hikvision',
    model: 'DS-PR1-WB-B-',
    category: 'alarm-panel',
    tagline: 'DS-PR1-WB-B- — 96-zone alarm panel, EN 50131 Grade Grade 2',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Alarm-Products/wireless-intrusion-alarm/ax-pro/ds-pr1-we/',
    specs: {
      series: 'AX Pro',
      zonesOnboard: 96,
      zonesMax: 96,
      partitions: 4,
      grade: 2,
      communicators: ['Ethernet', 'GSM-LTE', 'wireless'],
    },
  },
  {
    id: 'hikvision-ds-pr1-we-b',
    manufacturer: 'Hikvision',
    model: 'DS-PR1-WE-B-',
    category: 'alarm-panel',
    tagline: 'DS-PR1-WE-B- — 96-zone alarm panel, EN 50131 Grade Grade 2',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Alarm-Products/wireless-intrusion-alarm/ax-pro/ds-pr1-we/',
    specs: {
      series: 'AX Pro',
      zonesOnboard: 96,
      zonesMax: 96,
      partitions: 4,
      grade: 2,
      communicators: ['Ethernet', 'GSM-LTE', 'wireless'],
    },
  },
  {
    id: 'hikvision-ds-pr501-hwe',
    manufacturer: 'Hikvision',
    model: 'DS-PR501-HWE',
    category: 'alarm-panel',
    tagline: 'DS-PR501-HWE — 96-zone alarm panel, EN 50131 Grade Grade 3',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Alarm-Products/wired-intrusion-alarm/ax-hybrid-pro-g2/ds-pr501-hwe/',
    specs: {
      series: 'AX Pro',
      zonesOnboard: 8,
      zonesMax: 96,
      partitions: 4,
      grade: 3,
      outputsOnboard: 4,
      communicators: ['Ethernet', 'GSM-LTE', 'wireless'],
    },
  },
  {
    id: 'hikvision-ds-pr511-4',
    manufacturer: 'Hikvision',
    model: 'DS-PR511-4',
    category: 'alarm-panel',
    tagline: 'DS-PR511-4 — 256-zone alarm panel, EN 50131 Grade Grade 3',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Alarm-Products/wired-intrusion-alarm/ax-hybrid-pro-g2/ds-pr511-4/',
    specs: {
      series: 'AX Pro',
      zonesOnboard: 16,
      zonesMax: 256,
      partitions: 4,
      grade: 3,
      outputsOnboard: 8,
      communicators: ['Ethernet', 'GSM-LTE', 'wireless'],
    },
  },
  {
    id: 'hikvision-ds-pr521',
    manufacturer: 'Hikvision',
    model: 'DS-PR521',
    category: 'alarm-panel',
    tagline: 'DS-PR521 — 512-zone alarm panel, EN 50131 Grade Grade 3',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Alarm-Products/wired-intrusion-alarm/ax-hybrid-pro-g2/ds-pr521/',
    specs: {
      series: 'AX Pro',
      zonesOnboard: 32,
      zonesMax: 512,
      partitions: 4,
      grade: 3,
      outputsOnboard: 16,
      communicators: ['Ethernet', 'GSM-LTE', 'wireless'],
    },
  },
  {
    id: 'hikvision-ds-pr531-3a',
    manufacturer: 'Hikvision',
    model: 'DS-PR531-3A',
    category: 'alarm-panel',
    tagline: 'DS-PR531-3A — 1024-zone alarm panel, EN 50131 Grade Grade 3',
    verified: false,
    datasheetUrl: 'https://www.hikvision.com/en/products/Alarm-Products/wired-intrusion-alarm/ax-hybrid-pro-g2/ds-pr531-3a/',
    specs: {
      series: 'AX Pro',
      zonesOnboard: 64,
      zonesMax: 1024,
      partitions: 4,
      grade: 3,
      outputsOnboard: 32,
      communicators: ['Ethernet', 'GSM-LTE', 'wireless'],
    },
  },
];
